/**
 * Global Trademark & Registered Symbol Fix
 * Wraps ™ and ® symbols in <sup> tags across the site.
 * Handles static content and dynamically loaded content via MutationObserver.
 */
(function () {
    'use strict';

    // Symbols to look for: ™ (TM) and ® (Registered)
    const SYMBOL_REGEX = /(™|®)/g;

    /**
     * Replaces symbols in text nodes with <sup> wrapped elements
     * @param {Node} node - The DOM node to process
     */
    function processNode(node) {
        // Skip script, style, and already processed sup tags
        if (['SCRIPT', 'STYLE', 'SUP', 'TEXTAREA', 'INPUT'].includes(node.nodeName)) return;

        if (node.nodeType === Node.TEXT_NODE) {
            const text = node.nodeValue;

            // Check if text contains our symbols
            if (SYMBOL_REGEX.test(text)) {
                const fragment = document.createDocumentFragment();
                let lastIndex = 0;
                let match;

                // Reset regex state
                SYMBOL_REGEX.lastIndex = 0;

                while ((match = SYMBOL_REGEX.exec(text)) !== null) {
                    const matchIndex = match.index;
                    const symbol = match[0];

                    // Append text occurring before the symbol
                    if (matchIndex > lastIndex) {
                        fragment.appendChild(document.createTextNode(text.substring(lastIndex, matchIndex)));
                    }

                    // Create and append the superscript element
                    const sup = document.createElement('sup');
                    sup.textContent = symbol;
                    fragment.appendChild(sup);

                    lastIndex = matchIndex + symbol.length;
                }

                // Append any remaining text
                if (lastIndex < text.length) {
                    fragment.appendChild(document.createTextNode(text.substring(lastIndex)));
                }

                // Replace the original text node with the processed fragment
                node.parentNode.replaceChild(fragment, node);
            }
        } else if (node.nodeType === Node.ELEMENT_NODE) {
            // Recursively process child nodes
            // working with a static array copy because childNodes is live and we might be replacing nodes
            Array.from(node.childNodes).forEach(processNode);
        }
    }

    // Initialize on DOMContentLoaded
    document.addEventListener('DOMContentLoaded', () => {
        // 1. Process initial body content
        processNode(document.body);

        // 2. Observer for dynamically added content (AJAX, modifying DOM)
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((addedNode) => {
                    processNode(addedNode);
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
})();
